<script setup lang="ts">
import { loginState } from '../cross-app-frontend/firebase';
import ComplianceLayout from '@/ComplianceLayout.vue';
import { RouterView, useRoute } from 'vue-router';

const route = useRoute();
</script>

<template>
  <div v-if="loginState === 'initializing'" />
  <!-- The platform landing page is full-screen, without the app's sidebar. -->
  <RouterView v-else-if="loginState === 'logged-out' || route.name === 'Login' || route.name === 'Platform'" />
  <ComplianceLayout v-else />
</template>
